import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-table/react-table.css';

class UserFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: '',
      email: '',
    };
  }

  componentWillMount() {
    const { filters } = this.props;

    let filter = filters.find(f => f.field === 'email');
    if (filter) {
      this.setState({ email: filter.value });
    }
    filter = filters.find(f => f.field === 'phone');
    if (filter) {
      this.setState({ phone: filter.value });
    }
  }

  onSearch = () => {
    const { handleFiltersChange } = this.props;
    const {
      email, phone,
    } = this.state;

    handleFiltersChange([
      { field: 'email', operator: '=', value: email },
      { field: 'phone', operator: '=', value: phone },
    ]);
  };

  onReset = () => {
    const { handleFiltersChange } = this.props;

    this.setState({
      email: '',
      phone: '',
    });

    handleFiltersChange([]);
  };

  render() {
    const {
      email, phone,
    } = this.state;

    return (
      <div>
        <div className="row m-b-sm p-l-md">
          <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div className="filter row">
              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">Epasts:</div>
              <div className="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                <input onChange={e => this.setState({ email: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      this.onSearch();
                    }
                  }}
                  className="form-control"
                  value={email} />
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div className="filter row">
              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">Tālrunis:</div>
              <div className="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                <input onChange={e => this.setState({ phone: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      this.onSearch();
                    }
                  }}
                  className="form-control"
                  value={phone} />
              </div>
            </div>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-6 col-xs-12">
            <div className="filter row">
              <button type="button" onClick={this.onSearch}>
                Meklēt
              </button>
              <button type="button" onClick={this.onReset}>
                Notīrīt
              </button>
            </div>
          </div>
        </div>
        <hr className="line" />
      </div>
    );
  }
}

UserFilter.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape()),
  handleFiltersChange: PropTypes.func.isRequired,
};

UserFilter.defaultProps = {
  filters: [],
};

export default connect(
  state => ({
    filters: state.user.filters,
  }),
  null,
)(UserFilter);



// WEBPACK FOOTER //
// ./src/components/user/Filter.jsx